import { render } from "./The_root_causes_of_the_problem.vue?vue&type=template&id=e4138c2c&scoped=true"
import script from "./The_root_causes_of_the_problem.vue?vue&type=script&lang=js"
export * from "./The_root_causes_of_the_problem.vue?vue&type=script&lang=js"

import "./The_root_causes_of_the_problem.vue?vue&type=style&index=0&id=e4138c2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4138c2c"]])

export default __exports__